<template>
    <li>
        <div class="relative flex items-center justify-between gap-4">
            <button
                @click.prevent="copyLink"
                class="bg-v2-white border border-v2-white text-v2-gray-20 flex gap-3 items-center w-full p-3 rounded hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
            >
                <BaseSvg name="Share" class="fill-v2-gray-70 size-[18px] dark:fill-v2-gray-90"/>
                <span class="text-xs">Copy link</span>
            </button>
            <span ref="copyButton" class="confirmation-ready" aria-hidden="true">
                <BaseSvg name="Check" aria-hidden="true" class="size-4"/>
                Copied
            </span>
        </div>
    </li>
</template>

<script setup>
import {BaseSvg} from "@/Components";
import {ref} from "vue";

const props = defineProps(['url']);

const copyButton = ref();

function copyLink() {
    navigator.clipboard.writeText(props.url);
    copyButton.value?.classList.add('confirmation-run');
    setTimeout(() => {
        copyButton.value?.classList.remove('confirmation-run');
    }, 3000);
}
</script>
